import { render, staticRenderFns } from "./NavegacaoRegistros.vue?vue&type=template&id=52b5a1d0&"
import script from "./NavegacaoRegistros.vue?vue&type=script&lang=js&"
export * from "./NavegacaoRegistros.vue?vue&type=script&lang=js&"
import style0 from "./NavegacaoRegistros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports